<template>
  <div class="taskflow">
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-button type="primary" @click="add">新增</el-button>
    </el-row>
    <data-list
      style="margin-top: 10px"
      :data="data"
      :columns="columns"
      :loading="loading"
      :page="page"
      :page-size="page.pageSize"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
      :table-style="{ name: 'mixture' }"
    ></data-list>
    <el-dialog
      title="任务流配置"
      :visible.sync="dialogVisible"
      width="50%"
      center
      @closed="handleClose"
    >
      <!--<div style="height: 550px;">-->
      <el-scrollbar class="dialogScroll">
        <form-combination
          style="padding-right: 20px"
          size="small"
          :form-data="groups"
        ></form-combination>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue'
import messageSwitch from '@/components/customer/messageSwitch'
import listPageCreate from '@/mixins/listPageCreate'
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js'
import api from '@/backend/apiConfig/apiConfig'
import taskflow from '@/backend/services/task/taskflow'
import { serviceList } from '@/common/dictionary'
import setmeal from '@/backend/services/account/setmeal.js'
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js'
const page = listPageCreate({
  searchConfig: {
    api: api.taskflow.getTaskFlowList,
    method: 'POST',
  },
})
export default {
  name: 'taskflowList',
  components: {
    formCombination,
  },
  mixins: [page, beforeRouteEnter],
  data() {
    const that = this
    const columns = [
      {
        label: '任务流',
        bind: 'name',
      },
      {
        label: '业务线',
        bind: 'businessLineName',
      },
      {
        label: '任务类型',
        bind: 'typeName',
      },
      {
        label: '备注',
        bind: 'remark',
      },
      {
        label: '是否启用',
        type: 'custom',
        componentName: messageSwitch,
        inactiveValue: true,
        activeValue: false,
        event(row) {
          taskflow.changeTaskFlowStatus(row.id).then((val) => {
            if (val) {
              that.$message.success('更新状态成功')
            } else {
              that.$message.error('更新状态失败')
            }
          })
        },
        bind: 'disable',
      },
      {
        label: '操作',
        type: 'btnClick',
        align: 'center',
        width: 200,
        bind: [
          {
            text: '编辑',
            trigger: function(row, btn) {
              taskflow.getTaskFlowDetail(row.id).then((val) => {
                that.obj = val.data
                that.setGroups(val.data)
                that.dialogVisible = true
              })
            },
          },
          {
            text: '查看详情',
            trigger(row, btn) {
              that.$router.push({
                path: '/setting/taskflow/taskflowConf',
                query: {
                  id: row.id,
                  name: encodeURIComponent(row.name),
                },
              })
            },
          },
        ],
      },
    ]
    return {
      websiteList: [],
      groups: {},
      obj: {},
      dialogVisible: false,
      customer: {},
      btnLoading: false,
      type: 'add',
      columns: columns,
    }
  },
  methods: {
    add() {
      this.setGroups()
      this.dialogVisible = true
    },
    submit() {
      this.btnLoading = true
      let [requestApi, type] = [api.taskflow.addTaskFlow, 'Post']
      if (this.obj.id) {
        type = 'Put'
        requestApi = api.taskflow.editTaskFlow + this.obj.id
      }
      simpleFormPageCreate(
        {
          api: requestApi,
          type: type,
          data: this.groups,
        },
        (res) => {
          let obj = Object.assign({}, res)
          return obj
        }
      )
        .submit()
        .then(() => {
          this.btnLoading = false
          this.dialogVisible = false
          this.query()
        })
        .catch(() => {
          this.btnLoading = false
        })
    },
    handleClose() {
      this.obj = {}
      this.type = 'add'
    },
    isShow(formData, id) {
      return formData.correlation.value.some((item) => item === id)
    },
    async setGroups(obj = {}) {
      let res = await setmeal.getserveList()
      let keywordList = res.data
      const that = this
      that.groups = {
        name: {
          label: '任务流名称',
          formType: 'sky-input',
          value: obj.name,
        },
        type: {
          label: '任务流类型',
          formType: 'sky-select',
          options: serviceList,
          value: obj.type,
        },
        businessLineId: {
          label: '业务线',
          formType: 'sky-select',
          options: keywordList,
          props: {
            label: 'name',
            value: 'id',
          },
          value: obj.businessLineId,
        },
        remark: {
          label: '备注',
          formType: 'sky-input',
          type: 'textarea',
          value: obj.remark,
        },
      }
    },
  },
  mounted() {
    // this.query();
  },
}
</script>

<style scoped></style>
